<template lang="pug">
    el-dialog(title="查看队员",:fullscreen="false",:visible.sync="visible" width="45%" :append-to-body='true' :modal-append-to-body='false' @close="closeForm")
        el-row
            el-card(shadow="never" class='Leader' )
              div(slot="header")
                    font.font_label 领队
              div(class='LeaderList')
                el-form-item(label="姓名")
                    div.width_label {{Leader.name}}
                el-form-item(label="性别")
                    div.width_label {{Leader.gender==0?'男':Leader.gender==1?'女':''}}
                el-form-item(label="级别")
                    div.width_label {{Leader.level}}
                el-form-item(label="手机号码")
                    div.width_label {{Leader.mobile}}
            el-card(shadow="never" style='margin-top:20px')
                div(slot="header")
                    font.font_label 参赛人员
                div
                    el-table(:data="enrollClubMemberList" border max-height="300" )
                        el-table-column(prop="name" label="姓名" align='center')
                            //- template(slot-scope="scope")
                                //- font(style='color:red') {{scope.row.teamLeader==1?'领队':''}}
                                font()  {{scope.row.name}}
                        el-table-column(prop="gender" label="性别" align='center' )
                            template(slot-scope="scope")
                                font(v-if="scope.row.gender === 0") 男
                                font(v-if="scope.row.gender === 1") 女
                        el-table-column(prop="level" label="级别" align='center' )
                        el-table-column(prop="mobile" label="手机号码" align='center' )
            el-card(shadow="never" v-if="enrollClubSixMan && enrollClubSixMan.length>0" )
                div(slot="header")
                    font.font_label 第六人
                div
                    el-table(:data="enrollClubSixMan" border max-height="300")
                        el-table-column(prop="name" label="姓名" align='center')
                        el-table-column(prop="gender" label="性别" align='center' )
                            template(slot-scope="scope")
                                font(v-if="scope.row.gender === 0") 男
                                font(v-if="scope.row.gender === 1") 女
                        el-table-column(prop="level" label="级别" align='center' )
                        el-table-column(prop="mobile" label="手机号码" align='center' )
        span.dialog-footer(slot="footer")
            el-button(@click="visible = false") 确 定
</template>
<script>
import { getEnrollClubMemberTeamLeaderList } from '@/api/fqSelf/index.js'
export default {
  data () {
    return {
        Leader: {}, //领队
        visible: false,
        enrollClubMemberList: [], //当前俱乐部参赛人员
        enrollClubSixMan: [] //当前俱乐部参赛人员第六人
    }
  },
  methods: {
    //查看队员
    init (row) {
        this.visible = true
        this.enrollClubMemberList = []
        this.enrollClubSixMan = []
        const memberReq = this.$http({
            url: this.$http.adornUrl(`/mbMember/getEnrollClubMemberList`),
            method: 'GET',
            params: this.$http.adornParams({
                'enrollId': row.id
            })
        })
        const leaderReq = getEnrollClubMemberTeamLeaderList({
            ctId: row.ctId,
            clubId: row.participantInfoId
        })
        Promise.all([memberReq, leaderReq]).then(([memberRes, leaderRes]) => {
            if (memberRes && memberRes.code === 0) {
                this.enrollClubSixMan = memberRes.sixMan
                this.enrollClubMemberList = memberRes.list
            }
            if (leaderRes && leaderRes.code === 0) {
                this.Leader = (leaderRes.list && leaderRes.list[0]) || {}
            }
        })
    },

    closeForm () {
      this.visible = false
    }

  }
}
</script>
<style>
.Leader{
  margin-bottom: 20px;
}
.Leader .LeaderList{
  display: flex;
  justify-content: first baseline;
  flex-wrap: wrap;
}
</style>
